import React from 'react';

import { CircleInfoIcon } from '../Icons';
import styles from '../statics/styles/generic-error-scss';

interface Props {
  text: string;
  dataHook?: string;
}
const GenericError = ({ text, dataHook }: Props) => {
  return (
    <div className={styles.genericError} data-hook={dataHook}>
      <CircleInfoIcon />
      <div contentEditable={false}>{text}</div>
    </div>
  );
};

export default GenericError;
